module.exports = __webpack_public_path__ + "static/media/NoirPro-Bold.d9565816.eot";